<template>
    <div class="listmain ">
        <h1 class="firTitle">技能</h1>
        <p>语音交互技能是为了解决用户特定需求而由多种元素组成的完整集合。语音交互技能是智能硬件上的APP，它没有UI界面，通过语音进行交互。<br>
        语音技能主要由
        <router-link to='/tutor/zygn_zd' class="jc">词典</router-link>和<router-link to='/tutor/zygn_yt' class="jc">意图</router-link>构成。
          词典定义应用所在领域的关键词、术语。意图是用户的交互指令。
       </p>
        <h5 class="codeTitle">自定义技能</h5>
        <p >自定义技能有较强的定制化处理能力，开发者可以根据解析结果，在自己服务器开发相关逻辑
       </p>
        <router-link to='/tutor/zdyjn_ks' class="jc">
         查看文档教程
        </router-link>
         <h5 class="codeTitle">智能家居技能</h5>
        <p>为智能家居开发者提供了更加标准的开发接口，开发者仅需要少量配置和开发工作即可迅速完成技能
       </p>
       <router-link to='/tutor/znjjjn' class="jc">
         查看文档教程
        </router-link>

           <h5 class="codeTitle">有声内容技能</h5>
        <p>无需开发即可迅速创建技能，开发者仅需要按照指定步骤上传内容，即可完成开发
       </p>
       <router-link to='/tutor/ysnrjn' class="jc">
         查看文档教程
        </router-link>




    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }
.jc{
  // margin-top:-10px;
  margin-bottom: 10px;
  display: inline-block;
}
  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zygn_jn.vue